import React, { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules"; 
import "swiper/css";
import "swiper/css/pagination";
import "./category_tours.css";
import "./category_tours.scss";
import "swiper/css/navigation"; 
import axios from "axios"; // 👈 لازم
import { useNavigate } from "react-router-dom"; // 👈 أضف ده فوق

const CategoryTours = ({ onOpenModal }) => {
  
const [categories, setCategories] = useState([]);
const navigate = useNavigate(); // 👈 hook للتنقل

  useEffect(() => {
    axios.get("https://orangered-hornet-549881.hostingersite.com/api/destinations") // عدل الرابط حسب السيرفر
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.error("Error fetching destinations:", err);
      });
  }, []);

  return (
    <section className="mainCategory container section">
      <div className="secTitle">
        <span>Popular Categories</span>
        <h2 className="title">Best Egypt Tours and Travel Packages</h2>
        <p>
          Discover our best Egypt travel categories for Egypt trips to create
          your best Egypt tour plan. Experience the perfect Egyptian travel
          through our array of best categories. We offer a wide variety of tours
          in Egypt, offering something for all types of travelers who seek
          historic experiences or cultural insights and also want to experience
          luxurious relaxation. Experience the top Egypt vacation packages we
          offer for your chance to discover memorable moments throughout this
          historic territory. Every carefully selected package provided by our
          company offers exceptional Egyptian vacation experiences, which
          include desert tours alongside spectacular Nile River cruises.
        </p>
      </div>

      {/* التابات */}
      


    {/* المحتوى حسب التاب */}
<div className="categories-section container">
  <Swiper
    modules={[Autoplay, Pagination, Navigation]}
    autoplay={{ delay: 3000, disableOnInteraction: false }}
    pagination={{ clickable: true, el: ".swiper-pagination" }}
    navigation={true}
    spaceBetween={20}
    slidesPerView={4}
    loop={categories.length >= 4} // ✅ loop فقط لو فيه slides كفاية
    breakpoints={{
      320: { slidesPerView: 1, loop: categories.length >= 1 },
      768: { slidesPerView: 2, loop: categories.length >= 2 },
      1024: { slidesPerView: 3, loop: categories.length >= 3 },
    }}
  >
    {categories.map((cat) => (
      <SwiperSlide key={cat.id}>
        <div
          className="category-card"
          style={{
            backgroundImage: `url(https://orangered-hornet-549881.hostingersite.com/storage/${cat.image})`,
          }}
        >
          <div className="category-overlay">
            <h3>{cat.title}</h3>
            <p>{cat.description}</p>
            <button
              className="explore-btn"
              onClick={() => navigate(`/tours/${cat.id}`)}
            >
              Explore Now
            </button>
          </div>
          <div className="category-label">{cat.title}</div>
        </div>
      </SwiperSlide>
    ))}

    {/* النقاط */}
    <div className="swiper-pagination"></div>
  </Swiper>
</div>

   <div className="offer-one">
  <div className="offer-content">
    <h1>Make your Ideal Egypt Itinerary Now!</h1>
    <span className="offer-content-h3">Tailor Made Your Egypt Trips</span>
    <div className="tailor-made_spo d-grid_spo">
        <a
              href="#"
              className="theme-btn btn-style-three-spo"
              onClick={(e) => {
                e.preventDefault();
                onOpenModal(); // 👈 فتح المودال
              }}
            >
              Design Your Perfect Egypt Tour Now
            </a>
    </div>
  </div>
</div>

    </section>
  );
};

export default CategoryTours;
